import React from 'react';
import * as Styled from './styled';
import { Grid } from '@mlc/web-ui-toolkit';
import ApplyOnline from './ApplyOnline/ApplyOnline';
import palette from '@mlc/mlc-palette';
import SmallCapHeader from './Header/SmallCapHeader';
import Config from '../../../../AppConfig';

interface Props {
	forwardedRef: any;
	children: any;
}

const HeroTile: React.FunctionComponent<Props> = (props: Props) => (
	<Styled.ImageCard
		backgroundImg={
			Config.aemImageEnv +
			'content/dam/mlcsecure/adviser/images/adviser_home.jpg'
		}
		backgroundColor={palette.mlcBlack}
	>
		<Grid>
			<SmallCapHeader
				text="Welcome to AdviserOnline"
				forwardedRef={props.forwardedRef}
			/>
			<Styled.FlexBox>
				<Styled.Tile left>{props.children}</Styled.Tile>
				<Styled.Tile right>
					<ApplyOnline />
				</Styled.Tile>
			</Styled.FlexBox>
		</Grid>
	</Styled.ImageCard>
);

export default HeroTile;
